import styles from "./assets/css/NotFound.module.css";
import { Link } from "react-router-dom";
import ttLogo from "./assets/img/tech_touch_logo.png";

const NotFound = () => {
  return (
    <div className={styles.notFoundSection}>
      <div className={`${styles.notFoundSectionContainer} container`}>
        <img className={styles.logo} src={ttLogo} alt="technical touch logo" />
        <h1>Page Not Found</h1>
        <p>
          Use the below link to go back to the home page or if you think this
          page should exist, contact the site administrator.
        </p>
        <p>
          <Link to="/">Home Page</Link>
        </p>
      </div>
    </div>
  );
};

export default NotFound;
